import React, { useState } from "react";
import authService from "../../services/auth-service";
import "./ForgotPassword.scss";

const ForgotPassword = ({ navigateToLoginPage }) => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [step, setStep] = useState(1); // 1: Email entry, 2: Reset code, 3: New password
  const [resetToken, setResetToken] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleSendResetEmail = async () => {
    if (!validateEmail(email)) {
      setError("Please enter a valid email address");
      return;
    }

    try {
      setError("");
      setMessage("Processing your request...");
      
      const result = await authService.forgotPassword(email);
      
      if (result.success) {
        setMessage("Password reset instructions have been sent to your email. Please check your email for the reset code.");
        setStep(2);
      }
    } catch (err) {
      setError(err.message || "Failed to process your request");
      setMessage("");
    }
  };

  const handleResetPassword = async () => {
    if (!resetToken) {
      setError("Please enter the reset code from your email");
      return;
    }
    
    if (newPassword.length < 6) {
      setError("Password must be at least 6 characters long");
      return;
    }
    
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    try {
      setError("");
      setMessage("Resetting your password...");
      
      const result = await authService.resetPassword(resetToken, newPassword);
      
      if (result.success) {
        setMessage("Your password has been reset successfully");
        
        // Redirect to login page after 3 seconds
        setTimeout(() => {
          navigateToLoginPage();
        }, 3000);
      }
    } catch (err) {
      setError(err.message || "Failed to reset password");
      setMessage("");
    }
  };

  return (
    <div className="forgot-password-container">
      <h1>Reset Password</h1>
      
      {step === 1 && (
        <>
          <p>Enter your email address to receive password reset instructions</p>
          <div>
            <label>Email Address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
            />
          </div>
          <button onClick={handleSendResetEmail}>Send Reset Instructions</button>
        </>
      )}
      
      {step === 2 && (
        <>
          <p>Enter the reset code from your email and choose a new password</p>
          <div>
            <label>Reset Code</label>
            <input
              type="text"
              value={resetToken}
              onChange={(e) => setResetToken(e.target.value)}
              placeholder="Enter reset code"
            />
          </div>
          <div>
            <label>New Password</label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Enter new password"
            />
          </div>
          <div>
            <label>Confirm Password</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirm new password"
            />
          </div>
          <button onClick={handleResetPassword}>Reset Password</button>
        </>
      )}
      
      {error && <div className="error-message">{error}</div>}
      {message && <div className="success-message">{message}</div>}
      
      <div className="login-link" onClick={navigateToLoginPage}>
        Back to Login
      </div>
    </div>
  );
};

export default ForgotPassword;